import * as offerSelectors from '../offerSelectors.js';

import inList from './util/inList.js';
import lte from './util/lte.js';

export const monetization_type = inList(offerSelectors.monetization_type);
export const presentation_type = inList(offerSelectors.presentation_type);
export const provider = inList(offerSelectors.provider_id);
export const max_price = lte(offerSelectors.price);
